// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --blackBarHeight: 55px;
}

#gui-editor-workbench-root {
  display: grid;
  grid-template-rows: calc(100% - 55px);
  height: 100%;
  width: 100%;
  background: #e2e2e2;
  font: 14px "acumin-pro-condensed";
}

.wait-screen {
  display: grid;
  justify-content: center;
  align-content: center;
  height: 100%;
  width: 100%;
  background: #464646;
  opacity: 0.95;
  color: white;
  font: 24px "acumin-pro-condensed";
  position: absolute;
  top: 0;
  left: 0;
}
.wait-screen.hidden {
  visibility: hidden;
}

#leftGrab {
  width: 5px;
  height: 100%;
  cursor: ew-resize;
  position: absolute;
  right: -1px;
  top: 0;
}

#rightGrab {
  cursor: ew-resize;
  width: 5px;
  bottom: 0;
  position: absolute;
  top: 0;
  left: 0;
}

.toolbarGrab {
  background: #333333;
  grid-row: 1/span 3;
  grid-column: 2;
  height: 100%;
  overflow-y: auto;
}
.toolbarGrab .blackLine {
  height: 16px;
  background: black;
  position: relative;
}
.toolbarGrab .arrow {
  color: white;
  position: absolute;
}
.toolbarGrab .toolbar-label {
  color: white;
  font-size: 18px;
  display: grid;
  align-items: center;
  cursor: pointer;
  user-select: none;
  grid-template-columns: 1fr 20px;
  grid-template-rows: 100%;
  position: relative;
}
.toolbarGrab .toolbar-label.active {
  font-weight: bold;
  font-size: 20px;
}
.toolbarGrab .toolbar-label:hover {
  background: var(--selectionGrey);
}
.toolbarGrab .toolbar-label:hover .sub-items {
  display: block;
}
.toolbarGrab .toolbar-icon {
  width: 40px;
  height: 40px;
}
.toolbarGrab.expanded .toolbar-content-sub1 {
  column-count: 2;
}

.diagram-container {
  position: relative;
  display: grid;
  grid-row: 1;
  grid-column: 2;
  background: #cccccc;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.diagram-container .diagram {
  display: none;
  width: 100%;
  height: 100%;
}

.left-panel {
  grid-row: 1/span 2;
  grid-column: 1;
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: 1fr 50px;
  position: relative;
  overflow: hidden;
}
.left-panel.expand {
  grid-template-columns: 1fr 100px;
}

.right-panel {
  grid-row: 1/span 2;
  grid-column: 3;
  display: grid;
  grid-template-rows: 1fr 40px auto 40px;
  grid-template-columns: 100%;
  overflow-y: auto;
  position: relative;
}
.right-panel #propertyTab {
  grid-row: 1;
  grid-column: 1;
}
.right-panel .button {
  display: grid;
  justify-content: center;
  align-content: center;
  height: auto;
  width: 14.2857142857%;
  cursor: pointer;
}
.right-panel .button:hover {
  background: rgb(51, 122, 183);
  color: white;
  opacity: 0.8;
}
.right-panel .button.selected {
  background: rgb(51, 122, 183);
  color: white;
}
.right-panel .button.align {
  justify-content: stretch;
  text-align: center;
}

.blocker {
  visibility: hidden;
  position: absolute;
  width: calc(100% - 40px);
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(20, 20, 20, 0.95);
  font-family: "acumin-pro-condensed", sans-serif;
  color: white;
  font-size: 24px;
  display: grid;
  align-content: center;
  justify-content: center;
  user-select: none;
  padding: 20px;
  text-align: center;
}

#log-console {
  grid-row: 2;
  grid-column: 4;
  display: none;
}

.gizmo * {
  user-select: none;
}
.gizmo .bounding-box-line {
  background-color: black;
  position: absolute;
  line-height: 1px;
  height: 1px;
  pointer-events: none;
}
.gizmo .scale-point-container {
  position: absolute;
  width: 30px;
  height: 30px;
}
.gizmo .scale-point-container .scale-point {
  top: 10px;
  left: 10px;
  position: absolute;
  width: 10px;
  height: 10px;
  background: transparent;
  outline: rgb(125, 125, 125) 2px solid;
}
.gizmo .scale-point-container .rotate-click-area {
  width: 20px;
  height: 20px;
  position: absolute;
}
.gizmo .scale-point-container .scale-click-area {
  width: 20px;
  height: 20px;
  position: absolute;
}
.gizmo .pivot-point {
  width: 30px;
  height: 30px;
  background: transparent;
  position: absolute;
}

#workbench-canvas {
  position: relative;
}

.artboard-stroke {
  outline: 1px solid black;
  position: absolute;
  z-index: 2;
  pointer-events: none;
}

.artboard-background {
  position: absolute;
  background: repeating-conic-gradient(#e2e2e2 0% 25%, white 0% 50%) 50%/10px 10px;
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./../../../tools/guiEditor/dist/main.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;AACJ;;AAEA;EACI,aAAA;EACA,qCAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,iCAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AACJ;AACI;EACI,kBAAA;AACR;;AAGA;EACI,UAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AAAJ;;AAGA;EACI,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AAAJ;AAEI;EACI,YAAA;EACA,iBAAA;EACA,kBAAA;AAAR;AAEI;EACI,YAAA;EACA,kBAAA;AAAR;AAEI;EACI,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,wBAAA;EACA,kBAAA;AAAR;AAEQ;EACI,iBAAA;EACA,eAAA;AAAZ;AAGQ;EACI,gCAAA;AADZ;AAEY;EACI,cAAA;AAAhB;AAII;EACI,WAAA;EACA,YAAA;AAFR;AAKQ;EACI,eAAA;AAHZ;;AAQA;EACI,kBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AALJ;AAOI;EACI,aAAA;EACA,WAAA;EACA,YAAA;AALR;;AASA;EACI,kBAAA;EACA,cAAA;EACA,aAAA;EACA,wBAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;AANJ;AAOI;EACI,gCAAA;AALR;;AASA;EACI,kBAAA;EACA,cAAA;EACA,aAAA;EACA,sCAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;AANJ;AAQI;EACI,WAAA;EACA,cAAA;AANR;AASI;EACI,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;AAPR;AASQ;EACI,6BAAA;EACA,YAAA;EACA,YAAA;AAPZ;AAUQ;EACI,6BAAA;EACA,YAAA;AARZ;AAWQ;EACI,wBAAA;EACA,kBAAA;AATZ;;AAcA;EACI,kBAAA;EACA,kBAAA;EACA,wBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EAEA,kCAAA;EACA,+CAAA;EACA,YAAA;EACA,eAAA;EAEA,aAAA;EACA,qBAAA;EACA,uBAAA;EAEA,iBAAA;EAEA,aAAA;EACA,kBAAA;AAfJ;;AAkBA;EACI,WAAA;EACA,cAAA;EACA,aAAA;AAfJ;;AAmBI;EACI,iBAAA;AAhBR;AAkBI;EACI,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;AAhBR;AAkBI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AAhBR;AAiBQ;EACI,SAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,qCAAA;AAfZ;AAiBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAfZ;AAiBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAfZ;AAkBI;EACI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;AAhBR;;AAmBA;EACI,kBAAA;AAhBJ;;AAkBA;EACI,wBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;AAfJ;;AAiBA;EACI,kBAAA;EACA,gFAAA;EACA,WAAA;EACA,YAAA;AAdJ","sourcesContent":[":root {\r\n    --blackBarHeight: 55px;\r\n}\r\n\r\n#gui-editor-workbench-root {\r\n    display: grid;\r\n    grid-template-rows: calc(100% - 55px);\r\n    height: 100%;\r\n    width: 100%;\r\n    background: #e2e2e2;\r\n    font: 14px \"acumin-pro-condensed\";\r\n}\r\n\r\n.wait-screen {\r\n    display: grid;\r\n    justify-content: center;\r\n    align-content: center;\r\n    height: 100%;\r\n    width: 100%;\r\n    background: #464646;\r\n    opacity: 0.95;\r\n    color: white;\r\n    font: 24px \"acumin-pro-condensed\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n\r\n    &.hidden {\r\n        visibility: hidden;\r\n    }\r\n}\r\n\r\n#leftGrab {\r\n    width: 5px;\r\n    height: 100%;\r\n    cursor: ew-resize;\r\n    position: absolute;\r\n    right: -1px;\r\n    top: 0;\r\n}\r\n\r\n#rightGrab {\r\n    cursor: ew-resize;\r\n    width: 5px;\r\n    bottom: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n}\r\n\r\n.toolbarGrab {\r\n    background: #333333;\r\n    grid-row: 1 / span 3;\r\n    grid-column: 2;\r\n    height: 100%;\r\n    overflow-y: auto;\r\n\r\n    .blackLine {\r\n        height: 16px;\r\n        background: black;\r\n        position: relative;\r\n    }\r\n    .arrow {\r\n        color: white;\r\n        position: absolute;\r\n    }\r\n    .toolbar-label {\r\n        color: white;\r\n        font-size: 18px;\r\n        display: grid;\r\n        align-items: center;\r\n        cursor: pointer;\r\n        user-select: none;\r\n        grid-template-columns: 1fr 20px;\r\n        grid-template-rows: 100%;\r\n        position: relative;\r\n\r\n        &.active {\r\n            font-weight: bold;\r\n            font-size: 20px;\r\n        }\r\n\r\n        &:hover {\r\n            background: var(--selectionGrey);\r\n            .sub-items {\r\n                display: block;\r\n            }\r\n        }\r\n    }\r\n    .toolbar-icon {\r\n        width: 40px;\r\n        height: 40px;\r\n    }\r\n    &.expanded {\r\n        .toolbar-content-sub1 {\r\n            column-count: 2;\r\n        }\r\n    }\r\n}\r\n\r\n.diagram-container {\r\n    position: relative;\r\n    display: grid;\r\n    grid-row: 1;\r\n    grid-column: 2;\r\n    background: #cccccc;\r\n    width: 100%;\r\n    height: 100%;\r\n    overflow: hidden;\r\n\r\n    .diagram {\r\n        display: none;\r\n        width: 100%;\r\n        height: 100%;\r\n    }\r\n}\r\n\r\n.left-panel {\r\n    grid-row: 1 / span 2;\r\n    grid-column: 1;\r\n    display: grid;\r\n    grid-template-rows: 100%;\r\n    grid-template-columns: 1fr 50px;\r\n    position: relative;\r\n    overflow: hidden;\r\n    &.expand {\r\n        grid-template-columns: 1fr 100px;\r\n    }\r\n}\r\n\r\n.right-panel {\r\n    grid-row: 1 / span 2;\r\n    grid-column: 3;\r\n    display: grid;\r\n    grid-template-rows: 1fr 40px auto 40px;\r\n    grid-template-columns: 100%;\r\n    overflow-y: auto;\r\n    position: relative;\r\n\r\n    #propertyTab {\r\n        grid-row: 1;\r\n        grid-column: 1;\r\n    }\r\n\r\n    .button {\r\n        display: grid;\r\n        justify-content: center;\r\n        align-content: center;\r\n        height: auto;\r\n        width: calc(100% / 7);\r\n        cursor: pointer;\r\n\r\n        &:hover {\r\n            background: rgb(51, 122, 183);\r\n            color: white;\r\n            opacity: 0.8;\r\n        }\r\n\r\n        &.selected {\r\n            background: rgb(51, 122, 183);\r\n            color: white;\r\n        }\r\n\r\n        &.align {\r\n            justify-content: stretch;\r\n            text-align: center;\r\n        }\r\n    }\r\n}\r\n\r\n.blocker {\r\n    visibility: hidden;\r\n    position: absolute;\r\n    width: calc(100% - 40px);\r\n    height: 100%;\r\n    top: 0;\r\n    left: 0;\r\n\r\n    background: rgba(20, 20, 20, 0.95);\r\n    font-family: \"acumin-pro-condensed\", sans-serif;\r\n    color: white;\r\n    font-size: 24px;\r\n\r\n    display: grid;\r\n    align-content: center;\r\n    justify-content: center;\r\n\r\n    user-select: none;\r\n\r\n    padding: 20px;\r\n    text-align: center;\r\n}\r\n\r\n#log-console {\r\n    grid-row: 2;\r\n    grid-column: 4;\r\n    display: none;\r\n}\r\n\r\n.gizmo {\r\n    * {\r\n        user-select: none;\r\n    }\r\n    .bounding-box-line {\r\n        background-color: black;\r\n        position: absolute;\r\n        line-height: 1px;\r\n        height: 1px;\r\n        pointer-events: none;\r\n    }\r\n    .scale-point-container {\r\n        position: absolute;\r\n        width: 30px;\r\n        height: 30px;\r\n        .scale-point {\r\n            top: 10px;\r\n            left: 10px;\r\n            position: absolute;\r\n            width: 10px;\r\n            height: 10px;\r\n            background: transparent;\r\n            outline: rgb(125, 125, 125) 2px solid;\r\n        }\r\n        .rotate-click-area {\r\n            width: 20px;\r\n            height: 20px;\r\n            position: absolute;\r\n        }\r\n        .scale-click-area {\r\n            width: 20px;\r\n            height: 20px;\r\n            position: absolute;\r\n        }\r\n    }\r\n    .pivot-point {\r\n        width: 30px;\r\n        height: 30px;\r\n        background: transparent;\r\n        position: absolute;\r\n    }\r\n}\r\n#workbench-canvas {\r\n    position: relative;\r\n}\r\n.artboard-stroke {\r\n    outline: 1px solid black;\r\n    position: absolute;\r\n    z-index: 2;\r\n    pointer-events: none;\r\n}\r\n.artboard-background {\r\n    position: absolute;\r\n    background: repeating-conic-gradient(#e2e2e2 0% 25%, white 0% 50%) 50% / 10px 10px;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
